export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';

export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAILURE = 'USER_SIGNUP_FAILURE';

export const USER_ACCOUNT_ACTIVATION_SUCCESS = 'USER_ACCOUNT_ACTIVATION_SUCCESS';
export const USER_ACCOUNT_ACTIVATION_FAILURE = 'USER_ACCOUNT_ACTIVATION_FAILURE'; 
